/**
 * Implementation Pocketbase de AuthService.
 * Email + mot de passe (collection "users").
 */

import type { AuthService, AuthUser } from './auth';
import { pb } from './pocketbase-client';

function toAuthUser(record: { id: string; email: string; name?: string } | null): AuthUser | null {
  if (!record) return null;
  return {
    id: record.id,
    email: record.email,
    displayName: record.name ?? null,
  };
}

export const pocketbaseAuth: AuthService = {
  async signIn(email: string, password: string): Promise<void> {
    if (!pb) return;
    await pb.collection('users').authWithPassword(email, password);
  },

  async signUp(email: string, password: string, displayName?: string): Promise<void> {
    if (!pb) return;
    await pb.collection('users').create({
      email,
      password,
      passwordConfirm: password,
      name: displayName ?? '',
    });
    await pb.collection('users').authWithPassword(email, password);
  },

  async signOut(): Promise<void> {
    if (!pb) return;
    pb.authStore.clear();
  },

  async getUser(): Promise<AuthUser | null> {
    if (!pb) return null;
    if (!pb.authStore.isValid) return null;
    const model = pb.authStore.record;
    return toAuthUser(model as { id: string; email: string; name?: string } | null);
  },

  onAuthChange(callback: (user: AuthUser | null) => void): () => void {
    if (!pb) return () => {};
    const unsubscribe = pb.authStore.onChange((_token, record) => {
      callback(toAuthUser(record as { id: string; email: string; name?: string } | null));
    });
    return unsubscribe;
  },
};
